<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Delete Group</h1>
    <div class="modal-description">
      <p class="warning-text">
        Are you sure you want to delete
        <strong class="group-name-highlight">'{{ data.groupName }}'</strong>?
        This action cannot be undone.
      </p>
      <div class="group-detail">
        <ul>
          <li><span class="detail-label">Group Name:</span> <span class="detail-value">{{ data.groupName || 'N/A' }}</span></li>
          <li><span class="detail-label">Group Type:</span> <span class="detail-value">{{ data.groupType || 'N/A' }}</span></li>
        </ul>
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-delete" (click)="onConfirm()">Yes, Delete</button>
    </div>
  </div>
</div>
